import { Component } from 'react';
import PropTypes from 'prop-types';

import cx from 'classnames';


function dispatchResizeEvent() {
  const event = document.createEvent('HTMLEvents');
  event.initEvent('resize', true, false);
  window.dispatchEvent(event);
}

/**
 * Главный контейнер сайта, который используется
 * специалистами из рекламных технологий для изменения
 * поведения и размеров лэйаута, в зависимости от
 * начилия и конфигурации брендирования.
 *
 * Используется внутри корневого компонента приложения <App>.
 * Только в десктопной версии.
 *
 * Подробности тут:
 * https://jira.rambler-co.ru/browse/ADINBX-11068
 *
 */

// Класс ad-site-wrapper НЕ МЕНЯТЬ!!!
// На этот класс завязана реклама (брендирование)
export const AD_SITE_WRAPPER = 'ad-site-wrapper';
// Класс, который добавляется при маленькой ширине контейнера.
// По возможности лучше избегать привязки к этому классу и использовать
// только при крайней необходимости.
export const AD_SITE_WRAPPER_SMALL = `${AD_SITE_WRAPPER}-small`;

class DesktopAdSiteWrapper extends Component {
  state = {
    small: false,
  };

  componentDidMount() {
    if (!process.env.BROWSER_RUNTIME) return;

    const { minWidth } = this.props;
    /**
     * Когда прилетает брендирование, ширина контейнера может измениться.
     * При изменении ширины тригерим событие window.resize для того, чтобы
     * смогли обновиться некоторые виджеты, зависящие от ширины экрана.
     * Из известных - это swiper(галерея) и thinklink.
     */
    this.containerWidth = this.container.clientWidth;

    this.observer = new MutationObserver(() => {
      if (this.containerWidth !== this.container.clientWidth) {
        this.containerWidth = this.container.clientWidth;

        this.setSmallState(this.containerWidth <= minWidth);

        dispatchResizeEvent();
      }
    });

    this.observer.observe(this.container, {
      attributes: true,
    });

    this.mql = window.matchMedia(`(max-width: ${minWidth}px)`);
    if (this.mql.matches) {
      this.setSmallState(true);
    }
    this.mql.addListener(this.screenTest);
  }

  componentWillUnmount() {
    this.unmounted = true;
    this.observer && this.observer.disconnect();
    this.mql && this.mql.removeListener(this.screenTest);
  }

  setSmallState = isSmall => {
    this.setAtomicState({ small: isSmall });
  };

  screenTest = e => {
    this.setSmallState(e.matches);
  };

  setAtomicState(...args) {
    if (!this.unmounted) {
      this.setState(...args);
    }
  }

  render() {
    return (
      <div
        ref={node => { this.container = node; }}
        className={cx(AD_SITE_WRAPPER, this.state.small && AD_SITE_WRAPPER_SMALL)}
        style={{ margin: '0 auto' }}
      >
        {this.props.children}
      </div>
    );
  }
}

DesktopAdSiteWrapper.propTypes = {
  minWidth: PropTypes.number,
};

export default DesktopAdSiteWrapper;
